import React from "react";
import "../styles/main.css";

import "react-lazy-load-image-component/src/effects/opacity.css";

import VFF_mainPage from "../components/VFF_mainPage";
import VFF_fanFeatures from "../components/VFF_fanFeatures";
import { VFF_FanContent } from "../components/VFF_FanContent";
import FAQ from "../components/FAQs";
import Contact  from "../components/Contact";
import { faqsFans } from "../components/FAQs_QandAOnly";
import Footer from "../components/Footer";


const NewLandPage = () => {
  return (
    
    <>
    <VFF_mainPage />
    <VFF_fanFeatures />
    <VFF_FanContent />
    <FAQ questions={faqsFans} />
    <Footer/>
    </>
   
  );
};

export default NewLandPage;
